<template>
  <div class="header">
    <div class="items">
      <div class="tu">
        <img src="@/assets/imgs/public/header1.png" alt="" />
        <img src="@/assets/imgs/public/header2.png" alt="" />
      </div>
      <div
        class="item"
        v-for="(value, index) in data"
        :key="index"
        @click="go(value.name)"
      >
        {{ value.name }}
      </div>
    </div>
  </div>
</template>

<script>
import { cwslapi } from "@/api/index.js";

export default {
  data() {
    return {
      data: [
        {
          name: "官网首页",
          url: "/",
        },
        {
          name: "快速注册",
          url: "",
        },
        {
          name: "下载中心",
          url: "",
        },
        {
          name: "商城专区",
          url: "",
        },
        {
          name: "新闻中心",
          url: "",
        },
        {
          name: "充值中心",
          url: "",
        },
        {
          name: "玩家互动",
          url: "",
        },
      ],
    };
  },
  created() {},
  mounted() {},
  methods: {
    go(name) {
      switch (name) {
        case "官网首页":
          this.$router.push("/");
          break;
        case "快速注册":
          this.$message.error("请先退出当前账户");
          break;
        case "下载中心":
          this.$router.push("/downLoad");
          break;
        case "商城专区":
          const baseUrl = cwslapi.defaults.baseURL;
          if (baseUrl.indexOf("109.244.44.238:8000") == -1) {
            window.open("http://shop.818long.com/#/shop", "_blank");
          } else {
            window.open("http://testshop-mf.818long.com/#/shop", "_blank");
          }
          break;
        case "新闻中心":
          this.$router.push("/News");
          break;
        case "充值中心":
          this.$router.push("/recharge");
          break;
        case "玩家互动":
          window.open(
            "https://tieba.baidu.com/f?ie=utf-8&kw=%E5%AE%A0%E7%89%A9%E6%A3%AE%E6%9E%97&fr=search",
            "_blank",
          );
          break;
        default:
          break;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.header {
  width: 100%;
  height: 100px;
  background: rgba(255, 255, 255, 0.5);
  .tu {
    display: flex;
  }
  .items {
    width: 70%;
    height: 100%;
    margin: auto;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .item {
      height: 80px;
      line-height: 80px;
      font-size: 1.5rem;
      font-weight: 700;
      cursor: pointer;
    }
    .item:hover {
      color: #ffffff;
    }
  }
}
</style>
